module.exports = __webpack_public_path__ + "static/media/CTLI_10-235w.46286559.webp";